export default __webpack_public_path__ + "static/media/FAC3.ba413bfc.webp";